import React from 'react';
import './DateFilter.css';

const DateFilter = ({ 
  value, 
  onChange, 
  options, 
  label, 
  showCustom = false, 
  customDates = null, 
  onCustomDateChange = null 
}) => {
  const handlePeriodChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
    
    // Reset custom dates when changing period
    if (newValue !== 'custom' && onCustomDateChange) {
      onCustomDateChange({ start_date: '', end_date: '' });
    }
  };

  return (
    <div className="date-filter">
      <label className="filter-label">{label}</label>
      <div className="filter-controls">
        <select 
          value={value} 
          onChange={handlePeriodChange}
          className="period-select"
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        
        {showCustom && value === 'custom' && (
          <div className="custom-dates">
            <input
              type="date"
              value={customDates?.start_date || ''}
              onChange={(e) => onCustomDateChange({
                ...customDates,
                start_date: e.target.value
              })}
              className="date-input"
              placeholder="Start Date"
            />
            <span className="date-separator">to</span>
            <input
              type="date"
              value={customDates?.end_date || ''}
              onChange={(e) => onCustomDateChange({
                ...customDates,
                end_date: e.target.value
              })}
              className="date-input"
              placeholder="End Date"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateFilter; 